/**
 * Gera uma string aleatória que pode ser usada para ids temporários ou valores únicos
 * para essa sessão.
 *
 * @return {string}
 */
export function random() {
    return Math.random()
        .toString(36)
        .slice(2, 12)
}
